import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Box, LinearProgress } from "@mui/material";
import { useSelector } from "react-redux";

import UserChatBubble from "../../Forms/FirmUserBtn";

import SignaturePreview from "./SignaturePreview";

const FirmUserSignaturesTab = ({ signaturesData, onEditSignature }) => {
  const [selectedSignatureHover, setSelectedSignatureHover] = useState(null);
  const [isLoading, _setIsLoading] = useState(false);
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);

  return (
    <Row className="mx-0 pe-0">
      <Col md={12} className="p-0">
        <div
          style={{
            overflowY: "auto",
            width: "100%",
            scrollbarWidth: "none",
          }}
        >
          <table
            className="table table-borderless table-striped table-treatment has-specialty-icon has-height-25"
            style={{ width: "100%" }}
          >
            <thead
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "#f8f9fa",
                zIndex: 1,
              }}
            >
              <tr id="tb-header">
                <th
                  style={{
                    width: "25px",
                    maxWidth: "25px",
                  }}
                  className="td-autosize text-center"
                >
                  {/*  */}
                </th>

                <th className="text-center td-autosize color-grey-2">User Name</th>
                <th
                  className="text-center td-autosize color-grey-2"
                  style={{
                    minWidth: "150px",
                  }}
                >
                  Office
                </th>
                <th />

                <th
                  style={{
                    minWidth: "150px",
                  }}
                  className="text-center td-autosize color-grey-2"
                >
                  Email Signature
                </th>

                <th />
              </tr>
            </thead>
            {!isLoading ? (
              <tbody
                style={{
                  overflowY: "auto",
                  width: "100%",
                  scrollbarWidth: "none",
                }}
              >
                {signaturesData?.map((signature, idx) => {
                  return (
                    <tr
                      key={signature.id}
                      className="height-25"
                      style={{
                        cursor: "pointer",
                        backgroundColor:
                          selectedSignatureHover?.id === signature?.id
                            ? "white"
                            : idx % 2 === 0
                              ? "var(--primary-2)"
                              : "var(--primary-4)",
                      }}
                      onMouseEnter={() => setSelectedSignatureHover(signature)}
                      onMouseLeave={() => setSelectedSignatureHover(null)}
                      onClick={() => onEditSignature(signature)}
                    >
                      <td
                        className="text-center"
                        style={{ fontWeight: "600", color: "var(--primary-25)" }}
                      >
                        {idx + 1}
                      </td>
                      <td className="text-center color-black" style={{ fontWeight: "600" }}>
                        <div
                          className="d-flex align-items-center p-r-5 p-l-5 justify-content-center"
                          style={{
                            height: "25px",
                            gap: "5px",
                          }}
                        >
                          {signature.for_staff === null ? (
                            signature?.for_firm?.attorneyprofile?.office_name
                          ) : (
                            <>
                              <UserChatBubble
                                userId={signature?.for_staff?.user?.id}
                                first_name={signature?.for_staff?.user?.first_name}
                                last_name={signature?.for_staff?.user?.last_name}
                                profilePic={signature?.for_staff?.user?.profile_pic ?? ""}
                                width={29}
                                height={25}
                                isActive={
                                  userOnlineStatus?.[signature?.for_staff?.user?.id]?.isOnline ??
                                  false
                                }
                                is_active={signature?.for_staff?.user?.is_active}
                              />
                            </>
                          )}
                        </div>
                      </td>
                      <td className="text-center" style={{ fontWeight: "600" }}>
                        {signature?.use_office_contact
                          ? signature?.office_address?.nickname
                          : signature?.for_address?.nickname}
                      </td>

                      <td />

                      <td className="text-start color-black" style={{ fontWeight: "600" }}>
                        <SignaturePreview
                          signature={{
                            logoURL: signature?.logo_url,
                            userId: signature?.id,
                            userName:
                              signature?.for_staff === null
                                ? signature?.for_firm?.attorneyprofile?.office_name
                                : `${signature?.for_staff?.user?.first_name} ${signature?.for_staff?.user?.last_name}`,
                            userTitle: "",
                            ...(signature?.use_office_contact
                              ? signature?.office_address
                              : signature?.for_address),
                          }}
                        />
                      </td>

                      <td />
                    </tr>
                  );
                })}
                {Array.from({
                  length: 8 - (signaturesData ? signaturesData?.length : 0),
                }).map((_, index) => (
                  <tr key={index} className="fake-rows-new-provider height-25">
                    <td colSpan={9} />
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody
                style={{
                  overflowY: "auto",
                  width: "100%",
                  scrollbarWidth: "none",
                }}
              >
                {Array.from({
                  length: 8,
                }).map((_, index) => (
                  <tr key={index} className="fake-rows-new-provider height-25">
                    <td colSpan={9}>
                      <Box
                        sx={{
                          width: "100%",
                          paddingTop: "0px",
                          height: "25px",
                          alignContent: "center",
                        }}
                      >
                        <LinearProgress
                          sx={{
                            backgroundColor: "#8C9AAF",
                            "& .MuiLinearProgress-bar": {
                              backgroundColor: "#19395f",
                            },
                          }}
                        />
                      </Box>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </Col>
    </Row>
  );
};

export default FirmUserSignaturesTab;
